import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { LoadingStatus } from '../../core/domain/events/state_provider';
import { NotificationApi } from '../../data/dietitian/repositories/api/notification_api';
import { Appointment } from '../../data/patient/domain/appointment/appointment';
import { PatientSerieEventProvider } from '../../data/patient/domain/events/patient_serie/patient_serie_event_provider';
import { PatientSerieEvent } from '../../data/patient/domain/events/patient_serie/patient_serie_events';
import { Patient } from '../../data/patient/domain/patient';
import { PatientCommands } from '../../data/patient/domain/patient_commands';
import { PatientStateProvider } from '../../data/patient/domain/patient_state_provider';

export interface MyViewModel {
  isLoading: boolean;
  error: string;
  patient: Patient;
}

@Injectable()
export class MyFacade {
  constructor(
    private patientStateProvider: PatientStateProvider,
    private patientSerieEventProvider: PatientSerieEventProvider,
    private patientCommands: PatientCommands,
    private notificationApi: NotificationApi,
  ) {
    // nada
  }

  get myStatus$(): Observable<MyViewModel> {
    return this.patientStateProvider.state$.pipe(
      map((e) => {
        return <MyViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          patient: e.entity,
        };
      }),
    );
  }

  get patientSerieEvent$(): Observable<PatientSerieEvent> {
    return this.patientSerieEventProvider.events$;
  }

  async signOut(): Promise<void> {
    await this.patientCommands.signOut();
  }

  async findAllAppointment(patientId: string): Promise<Appointment[]> {
    return this.patientCommands.findAllAppointment(patientId);
  }

  loadActualWeight(patientId: string) {
    return this.patientCommands.getActualWeight(patientId);
  }

  loadActualSize(patientId: string) {
    return this.patientCommands.getActualSize(patientId);
  }

  requestNotification() {
    return this.notificationApi.requestPermission();
  }

  async updateTokenCurrentPatient(token: string) {
    return this.patientCommands.updateToken(token);
  }
}
